module.exports = __webpack_public_path__ + "static/SignupHero-ea0cf9daaee5cf7ab825e61d0401663f.svg";